var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Teleport',{attrs:{"to":_vm.to}},[_c('transition',{attrs:{"name":"bounce","appear":""}},[_c('div',{staticClass:"popup-info",style:(_vm.styleCustom),on:{"mouseleave":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"popup-info__body"},[_c('div',{staticClass:"popup-info__text"},[_vm._v(_vm._s(_vm.text))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c200ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/PopupInfo/PopupInfo.vue
// module id = null
// module chunks = 